<!-- https://router.vuejs.org/en/api/router-link.html -->
<template>
<!-- BUG can't scroll in Firefox up down -->
<!-- With touchless it does open on resize&&||reroute!! BUGFIX: disable route watcher to false-->
<!-- <v-navigation-drawer v-model="showdrawer" dark :disable-resize-watcher="false" :disable-route-watcher="false" floating hide-overlay mini-variant mini-variant-width="70" :stateless="false" :permanent="showdrawer" class="mydrawer"> -->

<!-- Keyword app prevents drawer from working on small devices! -->
<!-- BUG drawer opens bei expandable list on mobile. permanent would fix but also disable click-to-open in TitleBar -->
<!-- BUG in vuetify so menu button and swipe to open dont work together:
[Vue warn]: Avoid mutating a prop directly since the value will be overwritten whenever the parent component re-renders. Instead, use a data or computed property based on the prop's value. Prop being mutated: "showdrawer"
 -->
<v-navigation-drawer v-model="showdrawer" dark mini-variant mini-variant-width="70" hide-overlay stateless floating class="mydrawer">
  <div :style="$vuetify.breakpoint.smAndDown?'position:fixed;bottom:0px;max-height:100%;':''">
    <div :style="$vuetify.breakpoint.smAndDown?'position:relative;height:100%;':''">
      <router-link class="router-link" :to="item.path" :tabindex="(index+1)" v-for="(item,index) of this.$router.options.routes" v-if="item.inmenu" :key="item.name" :exact="item.path=='/'">
        <v-tooltip right :disabled="$vuetify.breakpoint.smAndDown">
          <div slot="activator" class="appicon">
            <v-icon class="menuicon">{{ item.icon }}</v-icon>
          </div>
          <span>{{ item.name }}</span>
          <!-- <span>{{ showdrawer }}</span> debug -->
        </v-tooltip>
      </router-link>
    </div>
    <router-link to="/desktop" class="router-link" :tabindex="this.$router.options.routes.length+1" v-if="$vuetify.breakpoint.smAndDown">
      <div class="appicon" style="background:#E95420;border-radius:0;overflow:hidden;margin:0px;margin-top:5px;width:70px;">
        <!--scale hack, otherwise margin around-->
        <img alt="" src="../assets/cof_white-orange_hex.svg" style="position:relative;width:150%;height:150%;overflow:hidden;transform:translate(-16.5%,-16.5%)">
      </div>
    </router-link>
  </div>
</v-navigation-drawer>
<!--</transition>-->
</template>
<script>
export default {
  name: "SideNav",
  data() {
    return {
      colorCache: Array()
    }
  },
  props: {
    showdrawer: {
        default: true
    }
  },
  methods: {
    randomColors() {
      var micons = document.getElementsByClassName("menuicon");
      for (var i = 0; i < micons.length; i++) {
        const r = () => 200 + Math.floor(56 * Math.random());
        var rl = Array();
        do {
          rl[0] = r();
          rl[1] = r() - 50 - Math.floor(206 * Math.random()); // Clearer defined color
          rl[2] = r() - 50 - Math.floor(50 * Math.random());
          rl.sort(function() {
            return 0.5 - Math.random();
          });
        } while (!this.validColor(rl));

        document.getElementsByClassName("menuicon")[i].style.color = "rgb(" + rl[0] + ", " + rl[1] + ", " + rl[2] + ")";
      }
    },
    validColor(rl) {
      if (((rl[0] + rl[1] + rl[2]) < 350)) { //Helligkeit

        if (this.colorCache.length != 0) { //Cache empty
          if (this.colorCache.indexOf(Math.max(...this.colorCache)) == rl.indexOf(Math.max(...rl))) { //not same color
            return false;
          }
        }
        this.colorCache = rl;
        return true;
      }
      return false;
    }
  },
  mounted: function() {
    this.randomColors();
  }
}
</script>
<style>
.slide-fade-enter-active {
  transition: all .2s ease;
}

.slide-fade-leave-active {
  transition: all .2s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  /*transform: translateX(-70px);*/
}


.mydrawer {
  /* max-height: 99vh !important; */
  /* max-height: 100% !important; /* Scroll doesnt work*/
  /* overflow: hidden !important; */
  overflow-y: auto !important;
  background: rgba(80, 80, 80, 0.1) !important;
  /* border-right:1px solid rgba(80,80,80,0.2); */
  box-shadow: none !important;
  padding-bottom: 0px;
  padding: 0px;
  margin: 0px;

  /* height:100%; wird autogeneriert. Desswegen wieder zurucksetzen */
  height: initial !important;
}


.appicon {
  cursor: pointer;
  text-align: center;
  border-radius: 5px;
  margin: 2px;
  height: 66px;
  /*used to be 64*/
  width: 66px;
  /* border: 1px dashed rgba(255, 255, 255, 0.2); */
}

.appicon:hover,
.router-link:active .appicon,
.router-link:focus .appicon,
.router-link-active .appicon {
  background: rgba(255, 255, 255, 0.1);
}

.router-link {
  outline: 0;
}

.appicon * {
  /*border:1px dashed white;
  border-radius: 100%;*/
  padding: 15px;
  font-size: 35px;
}

.router-link-active::before {
  content: '';
  margin-top: calc( ( 64px - 6px) / 2);
  margin-left: 5px;
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  border: 3px solid #E95420;
}

.v-navigation-drawer--close {
  width: 0px !important;
}

.v-navigation-drawer {
  transition: all .1s linear .2s;
}

.menuicon {
  /* This is about blue bars under the icons */

  /* Workaround for chrome */
  display: -webkit-inline-box;

  /* workaround for edge */
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/partials/SideNav.vue